import { InjectionToken, WritableSignal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

import { TellentClientConfig } from '../client';
import { TellentNavigationViewID, TellentNavigationScope } from '../client-navigation';
import { AppKind, TellentBrand, TellentCurrentUser } from '../types';

export const ORG_GUID = new InjectionToken<string | null>('Authorized organization GUID');
export const APP_GUID = new InjectionToken<string | null>('Authorized app GUID');
export const TELLENT_SUITE_ENABLED = new InjectionToken<boolean>('Tellent Suite feature flag');
export const TELLENT_NOT_AUTHORIZED = new InjectionToken<boolean>('Tellent not authorized');
export const BRAND = new InjectionToken<TellentBrand>(
  'Current brand in the context of the organization',
);
export const TELLENT_CURRENT_USER = new InjectionToken<TellentCurrentUser>(
  'Current user in the context of the organization',
);

export type TellentAdoptedStylesheetsSignal = WritableSignal<CSSStyleSheet[]>;
export const TELLENT_ADOPTED_STYLESHEETS = new InjectionToken<TellentAdoptedStylesheetsSignal>(
  'TELLENT_ADOPTED_STYLESHEETS',
);

export const TELLENT_CLIENT_CONFIG = new InjectionToken<TellentClientConfig>(
  'TELLENT_CLIENT_CONFIG',
);

export const { inject: injectTellentNavigationScope, provide: provideTellentNavigationScope } =
  createProviderToken<TellentNavigationScope[]>('TellentNavigationScope')();

export const { inject: injectTellentAppKind, provide: provideTellentAppKind } =
  createProviderToken<AppKind>('TellentAppKind')();

export const { inject: injectTellentNavigationViewID, provide: provideTellentNavigationViewID } =
  createProviderToken<TellentNavigationViewID>('TellentNavigationID')();

export const { inject: injectTellentSettingsLeaveUrl, provide: provideTellentSettingsLeaveUrl } =
  createProviderToken<string>('TellentSettingsLeaveUrl')();

export const {
  inject: injectTellentShellIsMinimalLayout,
  provide: provideTellentShellIsMinimalLayout,
} = createProviderToken<boolean>('TellentShellIsMinimalLayout')();
